import { ReactElement, PropsWithChildren } from "react";
import styles from "./ActivitiesContainer.module.less";

export const ActivitiesContainer = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return <div className={styles.root}>{children}</div>;
};

ActivitiesContainer.displayName = "ActivitiesContainer";